<template>
	<div class="expertInfo-component" @click="goCheckDetails">
		<div class="head">
			<img :src="expertInfo.photo" alt="" onerror="common.imgError(1,event)" v-if="expertInfo.photo">
			<img src="../../assets/images/defaultHead.png" alt="" v-if="expertInfo.photo==null">
		</div>
		<div class="info">
			<span>{{expertInfo.name}}</span>
			<p>{{expertInfo.company}}</p>
		</div>
	</div>
</template>
<script>
	export default{
		props:{
			expertInfo:{
				type:Object
			},
			// meetingId:{
			// 	type:Number,
			// 	default:0
			// }
		},
		watch:{

		},
		data(){
			return{
				meeting_id:0
			}
		},
		mounted(){
			this.meeting_id=this.$route.query.id;
		},
		methods:{

			goCheckDetails(){
				if(this.meeting_id){
					this.$router.push({
						path:'/expert/schedule',
						query:{
							meeting_id:this.meeting_id,
							writer_id:this.expertInfo.id
						}
					})
				}else{
					this.$router.push({
						path:'/expert/details',
						query:{
							id:this.expertInfo.id
						}
					})
				}
			}
		}
	}
</script>
<style lang="scss">
	.expertInfo-component{
		border-bottom:1px solid #ddd;
		padding:14px 0;
		@include flex(row);
		align-items:center;
		.head{
			width:40px;
			height:40px;
			img{
				width:100%;
				height:100%;
				border-radius:50%;
			}
		}
		.info{
			flex:1;
			margin-left:15px;
			span{
				color:$color-main;
				font-size:14px;
			}
			p{
				margin-top: 5px;
				color:$color-gray;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/Expert/ExpertInfo.vue